/**
 * Copyright Fitzba Technologies Inc. 2023
 *
 * Profile is a functional React component that displays a form for the user to view and edit their profile information.
 * The form includes fields for email, first name, last name, phone number, and postal/zip code.
 * The user can also change their password or delete their account.
 * The form data is sent to the server when the form is submitted.
 *
 * @author Yang Ming, James Nguyen
 * @version January 4th, 2024
 */

import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import './Profile.css'
import { Button, Popconfirm, message } from 'antd'
import PersonalInfo from './components/PersonalInfo'
import AddressInfo from './components/AddressInfo'
import UserPhoto from './components/UserPhoto'
import { deleteUser } from '@services/api.service'


export default function Profile() {
  const dispatch = useDispatch()
  const userinfo = useSelector(state => state.user.userinfo)
  const navigate = useNavigate()
  if (!userinfo) {
    navigate('/')
  }

  const confirm = async (e) => {
    console.log(e)
    // message.success('Click on Yes')
    try {
      const res = await deleteUser(userinfo._id)
      console.log('delete user res', res)
      message.success('Account deleted successfully.')
      localStorage.removeItem('token')
      // dispatch({ type: 'user/logout' })
      navigate('/')
    } catch (error) {
      console.error('Error deleting user:', error)
      message.error('Failed to delete account. Please try again later.')
      return
    }
  }
  const cancel = e => {
    console.log(e)
    // message.error('Click on No')
  }

  return (
    <div className='my-6 flex flex-col bg-white smsize:p-3'>
      <div className='m-auto w-full max-w-[1024px] flex flex-col gap-5 smsize:w-full'>
        <h1 className='uppercase text-left text-[30px] smsize:text-[20px]'>edit profile</h1>
        <UserPhoto userinfo={userinfo} dispatch={dispatch} />
        <PersonalInfo userinfo={userinfo} dispatch={dispatch} />
        <AddressInfo userinfo={userinfo} dispatch={dispatch} />
        <div className='flex justify-between items-center w-full'>
          <Popconfirm
            title="Delete the account?"
            description={`Are you sure to delete this account?
              This action cannot be undone.`}
            onConfirm={confirm}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type='primary' danger>Delete Account</Button>
          </Popconfirm>
        </div>
      </div>
    </div>
  )
}
